var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,128c-12.9,0-24.6,7.8-29.6,19.8s-2.2,25.7,7,34.8L256,365.3V480c0,8.5,3.4,16.6,9.4,22.6l64,64 c9.2,9.2,22.9,11.9,34.9,6.9S384,556.9,384,544V365.3l182.6-182.6c9.2-9.2,11.9-22.9,6.9-34.9S556.9,128,544,128H96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSolidFull);
export default __webpack_public_path__ + "static/media/filter-solid-full.3a9a9c7a831ec1c6f63fa12f93314872.svg";
export { ForwardRef as ReactComponent };